export default __webpack_public_path__ + "static/media/dashboard.8e5dfe0c.svg";